import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';


@Component({
  selector: 'my-infolabel',
  templateUrl: './InfoLabel.component.html'
})
export class InfoLabelComponent implements OnInit {

  
    @Input() public infoText: string;
    @Input() public labelText: string;

    constructor() 
    { 
    }


    ngOnInit(): void {
    }

}